import classNames from 'classnames';
import React from 'react';
import { ImageHelper } from '../ImageHelper/ImageHelper';
import { default as css } from './index.module.scss';

export interface KioskImageDisplayProps {
    left: { image: string; className?: string; alt?: string; };
    right:
    | {
        className?: string;
        header?: {
            text?: string;
            isAlertText?: boolean;
        };
        top?: {
            text?: string;
            isAlertText?: boolean;
        };
        image: string;
        bottom?: string;
        reminder?: string;
        alt?: string;
    }
    | {
        className?: string;
        component: React.ReactNode;
    };
}

/**
 * Displays a kiosk image and adjoining data appropriately.
 */
export const KioskImageDisplay = (props: KioskImageDisplayProps) => (
    <div className={css.kiosk}>
        <div className={classNames(css.left, props.left.className)}>
            <ImageHelper imageProps={{ src: props.left.image,
                alt: props.left.alt }}
            />
        </div>
        {(props.right && 'image' in props.right && (
            <div className={classNames(css.right, props.right.className)}>
                {props.right.header ? (
                    <div className={classNames(css.header, props.right.header.isAlertText ? css.alert : css.noAlert)}>
                        {props.right.header.text}
                    </div>
                ) : null}
                {props.right.top && <div className={classNames(css.top, props.right.top.isAlertText ? css.alert : css.noAlert)}>{props.right.top.text}</div>}
                <ImageHelper imageProps={{ src: props.right.image,
                    alt: props.right.alt }}
                />
                {props.right.bottom && <div className={css.bottom}>{props.right.bottom}</div>}
                {props.right.reminder && <div className={css.reminder}>{props.right.reminder}</div>}
            </div>
        )) ||
            (props.right && 'component' in props.right && <div className={classNames(css.right, props.right.className)}>{props.right.component}</div>)}
    </div>
);
